import { render, staticRenderFns } from "./TotalReceived.vue?vue&type=template&id=650eb452"
import script from "./TotalReceived.vue?vue&type=script&lang=js"
export * from "./TotalReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports